import Validator from 'validatorjs';
import validatorRuleEmail from './validatorRuleEmail';
const validateEmail = (data) => {
    const validation = new Validator(data, validatorRuleEmail);
    return validation;
};
export default validateEmail;
